import { render } from "./EmployeePayrollTax.vue?vue&type=template&id=5e5a1b71&scoped=true"
import script from "./EmployeePayrollTax.vue?vue&type=script&lang=js"
export * from "./EmployeePayrollTax.vue?vue&type=script&lang=js"

import "./EmployeePayrollTax.vue?vue&type=style&index=0&id=5e5a1b71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5a1b71"]])

export default __exports__